export default {
  label: {
    label: 'Label',
    placeholder: 'Add label',
    system: {
      name: 'label',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'label',
    rules: {
      title: 'Label field',
      required: true,
    }
  },
  description: {
    label: 'Description',
    placeholder: 'Fill-in this field',
    system: {
      name: 'description',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'description',
    rules: {
      title: 'Description',
      required: true,
    }
  },
  start_clock: {
    label: 'Start Clock',
    placeholder: '',
    system: {
      name: 'start_clock',
    },
    value: false,
    errors: [],
    type: 'checkbox',
    name: 'start_clock',
    rules: {}
  },
  email_template_id: {
    label: 'Email Template',
    placeholder: '',
    system: {
      name: 'email_template_id',
    },
    value: "0",
    errors: [],
    type: 'select',
    name: 'email_template_id',
    rules: {}
  },
  email_template: {
    label: 'Send to',
    placeholder: '',
    system: {
      name: 'email_template',
    },
    value: [],
    errors: [],
    type: 'text',
    name: 'email_template',
    rules: {
      title: 'Send To field',
      required: false,
    }
  }
};



// WEBPACK FOOTER //
// ./src/containers/EditStage/fields.js